import React from 'react';
import { Box, Button } from '@material-ui/core';
import Modal from 'components/Modal';
import { Input } from 'components/Form';
import clsx from 'clsx';
import classes from './Modal.module.scss';

const VerifyModal = ({ open, handleSubmit, handleClose }) => {
  const [note, setNote] = React.useState('');

  const resetState = () => {
    setNote('');
  };
  return (
    <Modal
      modalProps={{
        className: { classRoot: clsx(classes.root, classes.verifyModal) },
        open,
        handleClose: () => {
          handleClose(resetState);
        },
        title: 'File review',
        size: 'small',
        footer: (
          <>
            <Button
              className={clsx(classes.secondaryButton1)}
              variant='outlined'
              onClick={() => {
                handleSubmit(note, 'accepted', resetState);
              }}>
              Accept
            </Button>
            <Button
              className={clsx(classes.secondaryButton1)}
              variant='outlined'
              onClick={() => {
                handleSubmit(note, 'rejected', resetState);
              }}>
              Reject
            </Button>
            <Button
              className={clsx(classes.secondaryButton1)}
              variant='outlined'
              onClick={() => {
                handleSubmit(note, 'notApplicable', resetState);
              }}>
              Not Applicable
            </Button>
          </>
        ),
      }}>
      <Box>
        <p className={classes.noteLabel}>You can also write a note to your client</p>
        <Input
          inputProps={{}}
          className={classes.textArea}
          onChange={(event) => {
            setNote(event.target.value);
          }}
          value={note}
          multiline
          type='text'
          label='You can also write a note to your client'
          placeholder='Note (Optional)'
        />
      </Box>
    </Modal>
  );
};

export default VerifyModal;
